// @flow
import { render, hydrate } from 'react-dom';
import { loadableReady } from '@loadable/component';

export default function renderRoot(rootNode: React.Node) {
  const rootElement = document.querySelector('*[data-reactcontainer]');
  if (!rootElement) {
    return;
  }

  const ssrIsEnabled = rootElement.hasChildNodes();
  const renderFunc = ssrIsEnabled ? hydrate : render;
  if (ssrIsEnabled) {
    let namespace = 'legacyBuild';
    // If modern build loadable chunks exist, that means the experiment is enabled and the modern build happened.
    // Feature detect support for nomodule on script and if supported use modern build loadable chunks.
    if (
      typeof window !== 'undefined' &&
      document.getElementById('modernBuild__LOADABLE_REQUIRED_CHUNKS__')
    ) {
      if ('noModule' in HTMLScriptElement.prototype) {
        namespace = 'modernBuild';
      }
    }
    // See https://www.smooth-code.com/open-source/loadable-components/docs/server-side-rendering/#4-add-loadableready-client-side
    loadableReady(() => renderFunc(rootNode, rootElement), { namespace });
  } else {
    renderFunc(rootNode, rootElement);
  }
}
